import { i18n } from '@/commons/utils';

const URL_SmartsizeGuide =
  'rest/model/com/decathlon/cube/smartsize/actor/SmartSizeActor/guide';
const URL_SmartsizeSize =
  'rest/model/com/decathlon/cube/smartsize/actor/SmartSizeActor/size';

let modelCode = null;
let SmartSizeComponent = null;
const userLang = `${window.tc_vars.env_language}-${window.tc_vars.env_country}`;

const smartsizeModalControllerSelector = '#smartSize_modal_instance'; // checkbox instance controlling the modal
const smartsizeModalInstanceSelector = '.smartSize_modal'; // modal window instance

export const smartSizeTriggerSelector = '.js-trigger_smartsize_guide'; // "link" trigerring the smartsizeComponent (it's a <label> controlling a checkbox)

export function init() {
  let SmartSizeGuideDatas = null;
  const smartSizeTrigger = document.querySelector(smartSizeTriggerSelector);
  const smartsizeModalController = document.querySelector(smartsizeModalControllerSelector);
  const smartsizeModalInstance = document.querySelector(smartsizeModalInstanceSelector);

  smartSizeTrigger
    //we listen to a change event on the input linked to the label controlling the modal apparition
    .addEventListener('click', e => {
      e.preventDefault(); //prevent the default action (popin opening), we need to contact Smartsize API first
      modelCode = getCurrentModelCode();

      //if component already loaded, return
      if (
        smartsizeModalInstance.classList.contains('loaded') &&
        smartsizeModalInstance.classList.contains(`loaded-for-${modelCode}`)
      ) {
        //smartsize guide for this model already loaded, don't reinit the component, just make the modal visible again
        smartsizeModalController.click();
        return;
      }

      // get Smartsize informations (content of the sizeguide, if it exists)
      cube.ajax
        .get(
          `${URL_SmartsizeGuide}?modelCode=${getCurrentModelCode()}&language=${userLang}`
        )

        .onSuccess(response => {
          // check if errors *or* empty response :
          // either the smartsize API have a problem or the current product is not eligible
          if (response.responseTO.errors.length > 0 || response.responseTO.data === '') {
            // no smartsize guide available, revert to the classic behavior
            openOldSizeGuidePage();
            return;
          }

          smartsizeModalController.click(); //no errors from smartsize API : trigger the modal
          SmartSizeGuideDatas = JSON.parse(response.responseTO.data);

          //import dynamically the smartsize component and initialize it with the data from the API
          import('./smartsize_init').then(m => {
            smartsizeModalInstance.classList.add('loaded');
            removeClassByPrefix(smartsizeModalInstance, `loaded-for-`);
            smartsizeModalInstance.classList.add(`loaded-for-${modelCode}`);

            // if a previously smartsize component exists, destroy it
            // it can be the case if the user selected another model before
            if (SmartSizeComponent) {
              SmartSizeComponent.$destroy();
            }

            SmartSizeComponent = m.init(SmartSizeGuideDatas, getSuggestedSizes);

          });
        })
        .onError(response => {
          console.warn(`Error when calling smartSize API :\n ${response}`);
          openOldSizeGuidePage();
        })
        .call();
    });

  cube.event.on('modelChanged', (changedModelCode)=>{
    modelCode = changedModelCode;
    removeClassByPrefix(smartsizeModalInstance, `loaded-for-`);

  });


  function openOldSizeGuidePage() {
    const helpPageUrl = document.querySelector(smartSizeTriggerSelector).dataset.fallbackUrl;
    const windowOpen = window.open(helpPageUrl, '_blank');
    setTimeout(() => {
      if(!windowOpen) {
        window.location.href = helpPageUrl; // fallback really specific for safari on iphone
      }
    }, 300);
  }
}


/**
 * function to get the size suggestions from the smartsize API
 * this function is passed as a prop to the smartsize component
 *
 * @param {String} formdata (passed by the component) - responses entered by the user (TODO : not good, it should not be a string)
 * @param {Function} gotoNextstepCB (passed by the component) - callback function called after the suggestions are returned by the API : go to the next step
 */
function getSuggestedSizes(formdata, gotoNextstepCB) {
  const formdataJS = JSON.parse(formdata); // TODO : not good, it should not be a string

  formdataJS.model_code = modelCode;

  // replace space in values by _ (years old ==> years_old)
  Object.entries(formdataJS).forEach(([key, value])=> {
    formdataJS[key] = value.replace(/ /gi, '_');
  });

  const callParams = {
    sizeParameters: JSON.stringify(formdataJS), //sorry, Oracle ATG is sh**
    language: userLang,
  };

  cube.ajax
    .post(URL_SmartsizeSize, callParams)
    .onSuccess(res => {
      const sizes = JSON.parse(res.responseTO.data).size;
      setResultScreen(sizes);
      gotoNextstepCB(sizes);
    })
    .onError(res => {
      console.warn(res);
    })
    .call();
}

/**
 * set the final screen of the smartsize components :
 * buttons and actions when clicked
 *
 * @param {Array} sizeList
 */
function setResultScreen(sizeList) {
  let availableSize = null;
  let ChooseSizeBtn = null;
  const currentSizeList = getCurrentModelSizeList();

  //match the current available sizes with the ones returned by smartsize API
  availableSize = sizeList.map(e => e.size).filter(e => currentSizeList.includes(e))[0];

  if(availableSize){
    ChooseSizeBtn = {
      activate: '', // '' or  'disabled'
      className: 'ss_btn_class', // button class
      availlable: 'ss_btn_available_class btn', // available class
      label: i18n(`pdm.sizeGuide.choose`),
      handleClick: e => {
        // button click
        e.preventDefault();
        selectModelSizeAndCloseModal(availableSize);
      },
    };
  }

  SmartSizeComponent.$set({
    sizeResultBtn: ChooseSizeBtn,
    valueSize: availableSize || i18n(`pdm.sizeGuide.size.error`),
    sizeResultError: availableSize?'':i18n(`pdm.sizeGuide.technical.error`)
  });
}

/**
 * Select the corresponding size in the size selector of the model
 *
 * @param {String} size
 */
function selectModelSizeAndCloseModal(size) {


  const tabSizes = [...document.querySelectorAll(`[data-id="${modelCode}"] .sizes__info`)]
    .filter(e => e.textContent === size);

  tabSizes.forEach(e => {
    e.parentNode.click();
  });

  // close modal dialog
  document.querySelector(smartsizeModalControllerSelector).click();

  //trigger the animation
  const sizeSelectorSuggestedClass = 'sizes__button--smartsize-suggested';
  const sizeBtn = document.querySelector(`[data-id="${modelCode}"] .sizes__button`);
  sizeBtn.classList.remove(sizeSelectorSuggestedClass);
  sizeBtn.classList.add(sizeSelectorSuggestedClass);
}

/**
 * get the current Selected model code (for a mono-model product *or* a mulitmodel product)
 */
function getCurrentModelCode() {
  const modelMultiModel = document.querySelector(
    '.slider-nav-product-visual .slick-current'
  );

  if (modelMultiModel === null) {
    return document.querySelector('.js-default-model').dataset.modelId;
  }
  return modelMultiModel.dataset.modelId;
}

/**
 * Suppress all the classes of a DOM node that starts with the specified prefix
 *
 * @param {Node} node - DOM node to work on
 * @param {String} prefix - prefix of the classes to remove
 * @returns
 */
function removeClassByPrefix(node, prefix) {
  const regx = new RegExp(`\\b${  prefix  }[^ ]*[ ]?\\b`, 'g');
  node.className = node.className.replace(regx, '');
  return node;
}

/**
 * get the current model sizeList (from DOM :-/ )
 *
 * @returns Array(text) of sizes
 */
function getCurrentModelSizeList() {
  return [...document.querySelectorAll(`[data-id="${modelCode}"] .sizes__info`)].map(e => e.textContent);
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/smartsize-guide/smartsize.entry.js